import { View } from "backbone.marionette";
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

export default class CourseSubheaderView extends View.extend({
  events: {
    "click @ui.trigger": "clickTrigger"
  },

  ui: {
    trigger: '[data-behavior="view-toggle"]'
  }
}) {
  clickTrigger(event) {
    if (!window.VocatSubnavOverride) return;
    event.preventDefault();
    const el = event.currentTarget;
    const { route } = el.dataset;
    if (route && window.Vocat.router) {
      window.Vocat.router.navigate(route, true);
    }
    if (!$(el).hasClass("active")) {
      $(el).addClass("active");
    }
    return $(el)
      .siblings()
      .removeClass("active");
  }

  initialize(options) {
    this.vent = options.vent;
    return (this.$trigger = this.$el.find(this.getUI("trigger")));
  }
}
